import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialState } from './slice'

const calcState = (state: RootState) => state.calc

export const selectors = {
  selectWithdrawDataFromBalancesTab: createSelector(calcState, (state: typeof initialState) => state.withdrawDataFromBalancesTab),
  selectActionsFilterByExchange: createSelector(calcState, (state: typeof initialState) => state.actionsFilterByExchange),
  openConfirmDeleting: createSelector(calcState, (state: typeof initialState) => state.deletingTradeOption),

  selectSelectedTOBalance: ({ exchange, symbol }: { exchange: string; symbol: string }) =>
    createSelector(calcState, (state: typeof initialState) => {
      return (
        state?.selectedToBalances?.find(balance => balance.exchange === exchange && balance.symbol === symbol) ?? {
          _id: '',
          exchange,
          symbol,
          available: 0,
          onOrder: 0,
          total: 0,
          date: new Date(),
          wallets: [],
        }
      )
    }),
  selectPlaceOrderState: createSelector(calcState, (state: typeof initialState) => ({
    loading: state.placeOrderLoading,
    error: state.placeOrderError,
  })),
  selectWithdrawState: createSelector(calcState, (state: typeof initialState) => ({
    loading: state.withdrawLoading,
    error: state.withdrawError,
  })),

  selectActionsStatuses: createSelector(calcState, (state: typeof initialState) => ({
    firstActionsStatuses: state.firstActionsStatuses,
    secondActionsStatuses: state.secondActionsStatuses,
  })),

  // settings tab
  selectExchanges: createSelector(calcState, (state: typeof initialState) => state.settingsTab.exchangesList),
  selectMarkets: createSelector(calcState, (state: typeof initialState) => state.settingsTab.exchangeMarketsList),
  selectBotsSettigsList: createSelector(calcState, (state: typeof initialState) => state.settingsTab.botsListSettings),
  selectMarketsBotsList: createSelector(calcState, (state: typeof initialState) => state.settingsTab.marketsBotsListSettings),
  selectMarketsBotsListLoading: createSelector(calcState, (state: typeof initialState) => state.settingsTab.marketsBotsListSettingsLoading),
  //
  selectInfoMessage: createSelector(calcState, (state: typeof initialState) => state.infoPopup),
  selectDexFeeMarketExists: createSelector(calcState, (state: typeof initialState) => state.dexFeeMarketExists),

  selectInputData: createSelector(calcState, (state: typeof initialState) => state.inputsData),
  selectTradeOptionsHistory: createSelector(calcState, (state: typeof initialState) => state.tradeOptionsHistory),
  selectTabs: createSelector(calcState, (state: typeof initialState) => state.tabs),
  selectTradeOptionsHistoryPaused: createSelector(calcState, (state: typeof initialState) => state.isTradeOptionsHistoryPaused),
  selectSelectedTradeOption: createSelector(calcState, (state: typeof initialState) => state.selectedTradeOption),
  selectToken: createSelector(calcState, (state: typeof initialState) => state.token),
  selectPlaceOrderManualValues: createSelector(calcState, (state: typeof initialState) => state.placeOrderManualValues),
  selectTransferManualValues: createSelector(calcState, (state: typeof initialState) => state.transferManualValues),
  selectManualTab: createSelector(calcState, (state: typeof initialState) => state.manualActionsTab),
  selectTrades: createSelector(calcState, (state: typeof initialState) => state.trades),
  selectName: createSelector(calcState, (state: typeof initialState) => state.name),
  selectTradeFirstExType: createSelector(calcState, (state: typeof initialState) => state.tradeFirstExType),
  selectTradeSecondExType: createSelector(calcState, (state: typeof initialState) => state.tradeSecondExType),
  selectFormMenuOpened: createSelector(calcState, (state: typeof initialState) => state.formMenuOpened),
  selectTOFiltersByExchange: createSelector(calcState, (state: typeof initialState) => state.toFiltersByExchange),
  selectTOFiltersByMarket: createSelector(calcState, (state: typeof initialState) => state.toFiltersByMarket),
  selectTOFiltersBySymbol: createSelector(calcState, (state: typeof initialState) => state.toFiltersBySymbol),
  selecetTOFiltersByStatus: createSelector(calcState, (state: typeof initialState) => state.toFiltersByStatus),
  selectSearchTabState: createSelector(calcState, (state: typeof initialState) => state.searchTabState),
  selectOpenedTradeOption: createSelector(calcState, (state: typeof initialState) => state.openedTradeOption),
  selectedSortState: createSelector(calcState, (state: typeof initialState) => state.searchSortState),
  selectIsActionOpen: createSelector(calcState, (state: typeof initialState) => state.isActionOpen),
  selectRecordsTabOpened: createSelector(calcState, (state: typeof initialState) => state.recordsTabOpened),
  selectTimelineDot: createSelector(calcState, (state: typeof initialState) => state.selectedTimelineDot),
  selectIsHideRecorderTOList: createSelector(calcState, (state: typeof initialState) => state.isHideRecorderTOList),
}
